// extracted by mini-css-extract-plugin
export default {"paneCloseLinkArrow":"paneCloseLinkArrow---ECAT0","paneCloseLinkX":"paneCloseLinkX---iYX6s","paneCloseLink":"paneCloseLink---Cmksz"};